// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import * as MapSettingsActions from '../actions/map-settings.actions';
import { select, Store } from '@ngrx/store';
import * as fromMapSettingsSelectors from '../selectors/map-settings.selectors';

@Injectable()
export class MapSettingsEffects {
  loadMapSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MapSettingsActions.loadMapSettings),
      concatMap(() => {
        const mapSettings = JSON.parse(
          localStorage.getItem('mapSettingsConfig'),
        );
        return of(MapSettingsActions.loadMapSettingsSuccess({ mapSettings }));
      }),
    );
  });

  saveMapSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MapSettingsActions.saveMapSettings),
      withLatestFrom(
        this.store.pipe(
          select(fromMapSettingsSelectors.selectMapSettingsState),
        ),
      ),
      concatMap(([_, state]) => {
        localStorage.setItem(
          'mapSettingsConfig',
          JSON.stringify({ ...state, mapLoaded: false, selectedLayer: null }),
        );
        return of(MapSettingsActions.saveMapSettingsSuccess());
      }),
    );
  });

  constructor(
    private actions$: Actions,
    private store: Store,
  ) {}
}
